import { render, staticRenderFns } from "./q8.vue?vue&type=template&id=4038b48e&scoped=true"
import script from "./q8.vue?vue&type=script&lang=js"
export * from "./q8.vue?vue&type=script&lang=js"
import style0 from "./q8.vue?vue&type=style&index=0&id=4038b48e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4038b48e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\new-tis\\FR-TISSOT-IFB-Discovery-SFCC\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4038b48e')) {
      api.createRecord('4038b48e', component.options)
    } else {
      api.reload('4038b48e', component.options)
    }
    module.hot.accept("./q8.vue?vue&type=template&id=4038b48e&scoped=true", function () {
      api.rerender('4038b48e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "cartridges/int_guidedProductFinder/cartridge/client/default/js/components/questionTemplates/q8.vue"
export default component.exports